export const getSaleOrderPricing = (saleOrders, shopId) => {
  const totals = new Map();
  const weights = new Map();
  saleOrders.filter((order) =>
    String(order.status || "").toLowerCase() !== "close" &&
    (order.customer?.shopId == null || String(order.customer.shopId) === String(shopId)),
  ).forEach((order) => {
    (order.items || []).forEach((item) => {
      if (item.pricePerUnit == null) return;
      const remaining = Math.max(0, Number(item.weight || 0) - Number(item.actualWeight || 0));
      if (remaining <= 0) return;
      const id = Number(item.productId);
      const total = totals.get(id) || { sum: 0, count: 0 };
      total.sum += Number(item.pricePerUnit);
      total.count += 1;
      totals.set(id, total);
      weights.set(id, (weights.get(id) || 0) + remaining);
    });
  });
  return {
    prices: new Map([...totals].map(([id, total]) => [id, total.sum / total.count])),
    weights,
  };
};

export const calculateSpecialPrice = (costPrice, salePrice, incentive) =>
  costPrice == null || salePrice == null || incentive == null
    ? null
    : Number(costPrice) + ((Number(salePrice) - Number(costPrice)) * Number(incentive)) / 100;

export const getLockSellProductId = (lock) => Number(lock.sellProductId ?? lock.productId);

export const getLockSpecialPrice = (lock, saleOrderPrices) => {
  const headOfficePrice = lock.sorShopPrice ?? lock.headOfficePrice;
  const costPrice = headOfficePrice == null
    ? lock.costPrice
    : Number(headOfficePrice) + Number(lock.seeContractProfit ?? 1.5);
  const salePrice = lock.salePrice ?? saleOrderPrices.get(getLockSellProductId(lock)) ?? 0;
  return calculateSpecialPrice(costPrice, salePrice, lock.incentive ?? 40);
};
